<template>
    <div class="container-image-before-after" style="height: 100%">
        <div>
            <div>
                <TwentyTwenty
                    ref="twentytwenty"
                    :before="before"
                    :beforeLabel="beforeLabel"
                    :after="after"
                    :afterLabel="afterLabel"
                    v-if="doRender"
                    @click="triggerActionView"
                />
            </div>
        </div>
    </div>
</template>

<script>
import TwentyTwenty from "vue-twentytwenty-one"
import "~/vue-twentytwenty-one/dist/vue-twentytwenty-one.css"
export default {
    components: { TwentyTwenty },
    props: ["before", "after", "beforeLabel", "afterLabel", "image-view-event"],
    created() {
        window.eventBus.$on("slider-moved", () => {
            this.$refs.twentytwenty.resize()
        })
    },
    data() {
        return {
            isPopupOpen: false,
            doRender: true,
        }
    },
    methods: {
        triggerActionView(event) {
            if (this.imageViewEvent) {
                event.stopPropagation()

                if (!event.target.classList.has("twentytwenty-handle")) {
                    this.$root.$emit(this.imageViewEvent, this.before, this.after, this.beforeLabel)
                }
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.container-image-before-after {
    height: 100%;
    width: 100% !important;

    div {
        height: 100%;
    }

    img {
        height: 100%;
    }

    .twentytwenty-container {
        height: 100% !important;
        width: 100% !important;

        .twentytwenty-handle {
            transform: translateX(4px);
        }

        * {
            height: 100% !important;
        }

        img {
            height: 100% !important;
        }
    }
}
</style>
